export default "__VITE_ASSET__uPNibItG__"